"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheVisionaryEdge() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1404" id="the-visionary-edge" className="relative min-h-screen w-full overflow-hidden bg-background text-foreground">
      {}
      <video className="absolute inset-0 h-full w-full object-cover" autoPlay loop muted playsInline style={{
      playbackRate: 0.85
    }} poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701998/img/vivid_hero_poster.png">
        <source src="/img/vivid_hero_video.mp4" type="video/mp4" />
      </video>

      {}
      <div className="absolute inset-0 bg-background/60" aria-hidden="true"></div>

      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} aria-hidden="true"></div>

      {}
      <div className="absolute right-6 top-24 sm:right-10 sm:top-28 md:right-16 md:top-32 lg:right-24 lg:top-36 z-10" style={{
      animation: "stampOscillate 6s ease-in-out infinite"
    }} aria-hidden="true">
        <svg viewBox="0 0 140 140" className="h-[70px] w-[70px] sm:h-[100px] sm:w-[100px] md:h-[120px] md:w-[120px] lg:h-[140px] lg:w-[140px]" style={{
        transform: "rotate(9deg)"
      }}>
          <defs>
            <filter id="roughEdge1">
              <feTurbulence baseFrequency="0.05" numOctaves="2" />
              <feDisplacementMap in="SourceGraphic" scale="2" />
            </filter>
            <path id="circlePath1" d="M 70,70 m -50,0 a 50,50 0 1,1 100,0 a 50,50 0 1,1 -100,0" />
          </defs>
          <circle cx="70" cy="70" r="62" fill="none" stroke="hsl(210 100% 50%)" strokeWidth="1.5" filter="url(#roughEdge1)" />
          <circle cx="70" cy="70" r="52" fill="none" stroke="hsl(210 100% 50%)" strokeWidth="1" filter="url(#roughEdge1)" />
          <text fill="hsl(210 100% 50%)" style={{
          fontFamily: "JetBrains Mono, monospace",
          fontSize: "9.5px",
          letterSpacing: "0.15em",
          fontWeight: 500
        }}>
            <textPath href="#circlePath1" startOffset="0">
              VIVID STUDIO • EST. 2024 • GLOBAL •
            </textPath>
          </text>
          <text x="70" y="76" textAnchor="middle" fill="hsl(210 100% 50%)" style={{
          fontFamily: "Archivo Expanded, sans-serif",
          fontSize: "14px",
          fontWeight: 500,
          fontStyle: "italic"
        }}>
            VIVID
          </text>
          <text x="70" y="90" textAnchor="middle" fill="hsl(210 100% 50%)" style={{
          fontFamily: "JetBrains Mono, monospace",
          fontSize: "8px",
          letterSpacing: "0.2em"
        }}>
            CREATIVE
          </text>
        </svg>
      </div>

      {}
      <div className="absolute bottom-24 left-6 sm:bottom-28 sm:left-10 md:bottom-20 md:left-16 lg:left-24 z-10 hidden sm:block" style={{
      animation: "stampOscillate2 6s ease-in-out infinite"
    }} aria-hidden="true">
        <svg viewBox="0 0 140 140" className="h-[80px] w-[80px] md:h-[110px] md:w-[110px] lg:h-[130px] lg:w-[130px]" style={{
        transform: "rotate(-7deg)"
      }}>
          <defs>
            <filter id="roughEdge2">
              <feTurbulence baseFrequency="0.06" numOctaves="2" />
              <feDisplacementMap in="SourceGraphic" scale="2" />
            </filter>
            <path id="circlePath2" d="M 70,70 m -50,0 a 50,50 0 1,1 100,0 a 50,50 0 1,1 -100,0" />
          </defs>
          <circle cx="70" cy="70" r="62" fill="none" stroke="hsl(210 100% 50%)" strokeWidth="1.5" filter="url(#roughEdge2)" />
          <circle cx="70" cy="70" r="52" fill="none" stroke="hsl(210 100% 50%)" strokeWidth="1" filter="url(#roughEdge2)" />
          <text fill="hsl(210 100% 50%)" style={{
          fontFamily: "JetBrains Mono, monospace",
          fontSize: "9.5px",
          letterSpacing: "0.15em",
          fontWeight: 500
        }}>
            <textPath href="#circlePath2" startOffset="0">
              PRODUCTION • SCALE • IMPACT •
            </textPath>
          </text>
          <text x="70" y="74" textAnchor="middle" fill="hsl(210 100% 50%)" style={{
          fontFamily: "Archivo Expanded, sans-serif",
          fontSize: "13px",
          fontWeight: 500,
          fontStyle: "italic"
        }}>
            STUDIO
          </text>
          <text x="70" y="90" textAnchor="middle" fill="hsl(210 100% 50%)" style={{
          fontFamily: "JetBrains Mono, monospace",
          fontSize: "8px",
          letterSpacing: "0.2em"
        }}>
            VIVID
          </text>
        </svg>
      </div>

      {}
      <div className="absolute bottom-24 right-6 z-10 block sm:hidden" style={{
      animation: "stampOscillate2 6s ease-in-out infinite"
    }} aria-hidden="true">
        <svg viewBox="0 0 140 140" className="h-[70px] w-[70px]" style={{
        transform: "rotate(-7deg)"
      }}>
          <defs>
            <filter id="roughEdge3">
              <feTurbulence baseFrequency="0.06" numOctaves="2" />
              <feDisplacementMap in="SourceGraphic" scale="2" />
            </filter>
          </defs>
          <circle cx="70" cy="70" r="62" fill="none" stroke="hsl(210 100% 50%)" strokeWidth="1.5" filter="url(#roughEdge3)" />
          <circle cx="70" cy="70" r="52" fill="none" stroke="hsl(210 100% 50%)" strokeWidth="1" filter="url(#roughEdge3)" />
          <text x="70" y="74" textAnchor="middle" fill="hsl(210 100% 50%)" style={{
          fontFamily: "Archivo Expanded, sans-serif",
          fontSize: "13px",
          fontWeight: 500,
          fontStyle: "italic"
        }}>
            VIVID
          </text>
          <text x="70" y="90" textAnchor="middle" fill="hsl(210 100% 50%)" style={{
          fontFamily: "JetBrains Mono, monospace",
          fontSize: "8px",
          letterSpacing: "0.2em"
        }}>
            STUDIO
          </text>
        </svg>
      </div>

      {}
      <div className="relative z-20 flex min-h-screen items-center justify-center px-6 py-32 sm:px-10 md:px-16">
        <div ref={contentRef} className={`mx-auto w-full max-w-[980px] text-center transition-all duration-[900ms] ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
        transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
      }}>
          {}
          <div className="mb-10 font-mono text-xs sm:text-sm font-medium uppercase text-primary/70" style={{
          letterSpacing: "0.18em"
        }}>THE CREATIVE ENGINE</div>

          {}
          <h1 className="font-default font-normal text-foreground" style={{
          fontSize: "clamp(2.5rem, 7.5vw, 7.5rem)",
          lineHeight: 0.94,
          letterSpacing: "-0.025em"
        }}>
            Architects of visual{" "}
            <span className="text-primary" style={{
            fontStyle: "italic",
            fontWeight: 400
          }}>
              adrenaline
            </span>{" "}
            for modern brands.
          </h1>

          {}
          <div className="my-10 flex items-center justify-center gap-3">
            <div className="h-px w-40 bg-foreground"></div>
            <div className="h-1.5 w-1.5 rounded-lg bg-primary"></div>
          </div>

          {}
          <p className="mx-auto max-w-2xl font-default font-normal text-foreground/90" style={{
          fontSize: "clamp(1rem, 1.4vw, 1.25rem)",
          lineHeight: 1.55,
          letterSpacing: "-0.005em"
        }}>
            Full-service creative production agency. From initial concept mood boards to high-end commercial video spots, we scale your brand storytelling with precision.
          </p>

          {}
          <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-5">
            <Link to="/StartProjectPage">
              <Button size="lg" className="group h-auto rounded-lg border border-primary bg-primary px-8 py-4 font-default text-sm font-medium uppercase tracking-wider text-white shadow-md transition-colors duration-200 hover:bg-primary/85" style={{
              letterSpacing: "0.05em"
            }}>
                Start a Project
                <ArrowRight className="ml-1 h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
              </Button>
            </Link>
            <Link to="/OurWorkPage">
              <Button size="lg" variant="outline" className="h-auto rounded-lg border border-foreground bg-transparent px-8 py-4 font-default text-sm font-medium uppercase tracking-wider text-foreground shadow-md transition-colors duration-200 hover:bg-foreground hover:text-background" style={{
              letterSpacing: "0.05em"
            }}>
                View Capabilities Deck
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-6 right-6 z-10 hidden md:block">
        <div className="font-mono text-xs text-foreground/70" style={{
        letterSpacing: "0.08em"
      }}>
          VIVID // STUDIO
        </div>
        <div className="mt-1 font-mono text-xs text-foreground/50" style={{
        letterSpacing: "0.08em"
      }}>
          GLOBAL · PRODUCTION
        </div>
      </div>

      {}
      <div className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 md:hidden">
        <div className="font-mono text-[10px] text-foreground/70" style={{
        letterSpacing: "0.08em"
      }}>
          VIVID // STUDIO
        </div>
      </div>

      {}
      <style>{`
        @keyframes stampOscillate {
          0%, 100% { transform: rotate(7.5deg); }
          50% { transform: rotate(10.5deg); }
        }
        @keyframes stampOscillate2 {
          0%, 100% { transform: rotate(-8.5deg); }
          50% { transform: rotate(-5.5deg); }
        }
      `}</style>
    </section>;
}